import PropTypes from "prop-types";
import { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { obtenerParametrosPorTipos } from "../../../Parametros/services/parametros-service";

const FormAvancesSolicitud = ({ modalState, onSave }) => {
    const { solicitud } = modalState.data;
    const [tipoIntervencion, setTipoIntervencion] = useState([]);
    const [tipoProveedor, setTipoProveedor] = useState([]);

    useEffect(async () => {
        const resp = await obtenerParametrosPorTipos("tipo_intervencion");
        if (!resp.status) return toast.error(resp.message);

        setTipoIntervencion(
            resp.data.map((tipoIntervencion) => {
                return {
                    label: tipoIntervencion.nombre,
                    value: tipoIntervencion.id,
                };
            })
        );
    }, []);

    useEffect(async () => {
        const resp = await obtenerParametrosPorTipos("proveedores");
        if (!resp.status) return toast.error(resp.message);

        setTipoProveedor(
            resp.data.map((tipoProveedor) => {
                return {
                    label: tipoProveedor.nombre,
                    value: tipoProveedor.id,
                };
            })
        );
    }, []);

    const campos = {
        solicitud_id: solicitud.id,
        empleados: solicitud.empleados != null ? solicitud.empleados : [],
        observacion: "",
    };

    const form = useForm({
        defaultValues: campos,
    });

    useEffect(() => {
        form.reset(campos);
    }, [solicitud.id]);

    const onCreateAvances = async () => {
        modalState.close();
        onSave();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formRequerimientos"
            isOpen={modalState.show}
            onSubmit={onCreateAvances}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    name="id"
                    type="hidden"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={6}>
                    <InputController
                        label="Solicitud"
                        name="solicitud_id"
                        control={form.control}
                        errors={form.formState.errors}
                        readOnly={true}
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        errors={form.formState.errors}
                        name="intervencion_id"
                        label="Tipo Intervención "
                        control={form.control}
                        options={tipoIntervencion}
                        rules={{
                            required: "Este campo es requerido",
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <SelectController
                        errors={form.formState.errors}
                        name="proveedor_id"
                        label="Proveedor"
                        control={form.control}
                        options={tipoProveedor}
                        rules={{
                            required: "Este campo es requerido",
                        }}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        type="file"
                        multiple
                        label="Adjuntar Archivo (opcional)"
                        errors={form.formState.errors}
                        control={form.control}
                        name="flujograma[]"
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    <InputController
                        type="textarea"
                        label="Descripción de la Solución"
                        errors={form.formState.errors}
                        control={form.control}
                        name="descripcion"
                        placeholder="Descripción"
                        rules={{
                            required: "Este campo es requerido",
                        }}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormAvancesSolicitud.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func,
};

export default FormAvancesSolicitud;
